import React from 'react';

import { NextPage } from 'next';

import { Typography } from '@mui/material';

import { MyConversationsInboxType } from '@kamernet/core/ApiClient/Kamernet';
import { useIntl } from '@kamernet/core/Intl';
import { PageLayout } from '@kamernet/core/PageLayout';
import { ROUTES } from '@kamernet/core/Routing';
import { NavLink } from '@kamernet/core/Routing/NavLink';

import styles from './ErrorNotFound.module.css';

const ErrorNotFound: NextPage = () => {
  const { T, locale } = useIntl();

  const ERROR_CODE_HEADING = '404';

  return (
    <PageLayout pageTitle={T('LBL_PAGETITLE_APPLICATION_ERROR')}>
      <PageLayout.MainContainer>
        <PageLayout.SectionContainer className={styles.root}>
          <Typography
            fontSize={48}
            variant="body2"
            fontWeight={700}
            marginBottom={3}
          >
            {ERROR_CODE_HEADING}
          </Typography>
          <Typography
            fontSize={28}
            variant="body2"
            fontWeight={600}
            lineHeight={1.2}
            marginBottom={2}
          >
            {T('400_error_page.heading.doesnt_exist')}
          </Typography>
          <Typography variant="body2" marginBottom={2}>
            {T('400_error_page.subheading.helpful_links')}
          </Typography>
          <div className={styles.linksContainer}>
            <div className={styles.links}>
              <NavLink.Anchor
                href={ROUTES.HowDoesItWorkTenant.url({}, locale)}
                fontWeight={600}
              >
                {T('LBL_HOW_DOES_IT_WORK_MENU')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.PublicProfile.url({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_PUBLIC_PROFILE')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.LCFStart.url({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_CREATE_AD')}
              </NavLink.Anchor>

              <NavLink.Anchor
                href={ROUTES.Settings.url({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MY_SETTINGS')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyListings.url({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MANAGE_AD')}
              </NavLink.Anchor>
            </div>
            <div className={styles.links}>
              <NavLink.Anchor
                href={ROUTES.MyAccount.url({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MY_PREMIUM_ACCOUNT')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyConversations.url(
                  { inboxType: MyConversationsInboxType.Default },
                  locale,
                )}
                fontWeight={600}
              >
                {T('LBL_404_MY_MESSAGES')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyFavoriteRooms.url({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MY_FAVORITE_ROOMS')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.MyFavoriteTenants.url({}, locale)}
                fontWeight={600}
              >
                {T('LBL_404_MY_FAVORITE_TENANTS')}
              </NavLink.Anchor>
              <NavLink.Anchor
                href={ROUTES.AccountAlerts.url({}, locale)}
                fontWeight={600}
              >
                {T('LBL_GLOBAL_ALERTS')}
              </NavLink.Anchor>
            </div>
          </div>
        </PageLayout.SectionContainer>
      </PageLayout.MainContainer>
    </PageLayout>
  );
};

export default ErrorNotFound;
